// extracted by mini-css-extract-plugin
export var footer = "d_H";
export var footerBottom = "d_V";
export var footerTop = "d_J";
export var footerTopQrcode = "d_K";
export var footerTopQrcodeBox = "d_L";
export var footerTopQrcodeBoxImg = "d_M";
export var footerTopQrcodeText = "d_N";
export var footerTopQrcodeTextHighlight = "d_P";
export var footerTopRight = "d_Q";
export var footerTopRightAddress = "d_T";
export var footerTopRightDescription = "d_S";
export var footerTopRightLogo = "d_R";